<template>
  <form @submit.prevent="create" id="my-account-user-invite">
    <div class="alert -success" v-if="finished">
      <p>Usuário foi confidado com sucesso. Ele receberá um email para criar uma senha!</p>
    </div>

    <div class="alert -danger" v-if="errors.unrecognized">
      <p>Ocorreu um erro desconhecido ao alterar as informações, por favor tente novamente.</p>
    </div>

    <div class="form-group" :class="{ '-has-error': errors.form.name.length > 0 }">
      <label for="name" class="label">Nome</label>
      <input
        type="text"
        id="name"
        name="name"
        class="form-control"
        v-model="form.name"
        autocomplete="off"
        required
      >
      <p class="description" v-if="errors.form.name.length > 0">{{ errors.form.name[0] }}</p>
    </div>

    <div class="form-group" :class="{ '-has-error': errors.form.email.length > 0 }">
      <label for="email" class="label">E-mail</label>
      <input
        type="text"
        id="email"
        name="email"
        class="form-control"
        v-model="form.email"
        autocomplete="off"
        required
      >
      <p class="description" v-if="errors.form.email.length > 0">{{ errors.form.email[0] }}</p>
    </div>

    <div class="form-group" :class="{ '-has-error': errors.form.role.length > 0 }">
      <label for="email" class="label">Permissão</label>
      <select
        id="role"
        name="role"
        class="form-control"
        v-model="form.role"
        required
      >
        <option value="">Selecione...</option>
        <option value="1">Master</option>
        <option value="2">Operador</option>
      </select>
      <p class="description" v-if="errors.form.role.length > 0">{{ errors.form.role[0] }}</p>
    </div>

    <div class="flex" style="justify-content: flex-end">
      <button class="btn btn-default" type="button" @click="back">Voltar</button>
      <button class="btn btn-primary ml-2" type="submit">Salvar</button>
    </div>

    <loader v-if="loading"/>
  </form>
</template>

<script>
import Loader from '@/support/components/Loader.vue';
import checkErrorIsUnrecognizedResponse from '@/support/helpers/checkErrorIsUnrecognizedResponse';

export default {
  name: 'UserInvite',

  data() {
    return {
      loading: false,
      finished: false,
      form: {
        name: '',
        email: '',
        role: '',
      },
      errors: {
        unrecognized: false,
        form: {
          name: [],
          email: [],
          role: [],
        },
      },
    };
  },

  methods: {
    /**
     * Update the organization information.
     *
     * @returns {Promise<void>}
     */
    async create() {
      try {
        this.finished = false;
        this.loading = true;
        this.resetErrors();

        await this.$store.dispatch('auth/sendInvite', this.form);

        this.finished = true;

        this.form.name = '';
        this.form.email = '';
        this.form.role = '';
      } catch (err) {
        if (checkErrorIsUnrecognizedResponse(err, [422])) {
          this.errors.unrecognized = true;
          return;
        }

        const { data, status } = err.response;

        if (status === 422) {
          this.errors.form.name = data.errors.name || [];
          this.errors.form.email = data.errors.email || [];
          this.errors.form.role = data.errors.role || [];
        }
      } finally {
        this.loading = false;
      }
    },

    back() {
      this.$router.back();
    },

    /**
     * Reset the errors page.
     */
    resetErrors() {
      this.errors.form.name = [];
      this.errors.form.cnpj = [];
      this.errors.form.role = [];
      this.errors.unrecognized = false;
    },
  },

  directives: {
  },

  components: {
    Loader,
  },
};
</script>

<style scoped>

</style>
